import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { EPeriodicStatus, EPeriodicStatusKeysType } from "../../../../models/periodic/periodic";

interface PeriodicStateChartData {
    validatePercentage: number;
    plannedPercentage: number;
    verifiedPercentage: number;
    latePercentage: number;
    refusedPercentage: number;
}

const PeriodicStateChart = ({ data }: { data: PeriodicStateChartData }) => {
    const colors = ['#94ca58', '#acadac', '#65a6fa', '#fe914d', '#fd4343'];
    const { t } = useTranslation(["periodical"]);

    const chartOptions = {
        labels: [
            t(`status.${EPeriodicStatus[EPeriodicStatus.Accepted] as EPeriodicStatusKeysType}`),
            t(`status.${EPeriodicStatus[EPeriodicStatus.Todo] as EPeriodicStatusKeysType}`),
            t(`status.${EPeriodicStatus[EPeriodicStatus.ToVerify] as EPeriodicStatusKeysType}`),
            t(`status.${EPeriodicStatus[EPeriodicStatus.Overdue] as EPeriodicStatusKeysType}`),
            t(`status.${EPeriodicStatus[EPeriodicStatus.Refused] as EPeriodicStatusKeysType}`),
        ],
        fill: {
            colors,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "60%"
                }
            }
        },
        colors,
        markers: {
            colors,
        },
    };

    const chartData = {
        series: [
            data.validatePercentage,
            data.plannedPercentage,
            data.verifiedPercentage,
            data.latePercentage,
            data.refusedPercentage
        ], 
    };

    return (
        <ReactApexChart
            options={chartOptions}
            series={chartData.series}
            type="pie"
            width="100%"
            height='110%'
        />
    );
};

export default PeriodicStateChart;
